export default function (id) {
  var self = this
  var startX = 0
  var x = 0

  // retrieve touch button
  var slider = document.getElementById(id)
  var touchRight = slider.querySelector('.slider-touch-right')
  var lineSpan = slider.querySelector('.slider-line span')

  // get some properties
  var min = parseFloat(slider.getAttribute('se-min'))
  var max = parseFloat(slider.getAttribute('se-max'))

  // retrieve default values
  var defaultValue = min
  if (slider.hasAttribute('se-value')) {
    defaultValue = parseFloat(slider.getAttribute('se-value'))
  }

  // check values are correct
  if (defaultValue < min) {
    defaultValue = min
  }

  if (defaultValue > max) {
    defaultValue = max
  }

  var step = 0.0

  if (slider.getAttribute('se-step')) {
    step = Math.abs(parseFloat(slider.getAttribute('se-step')))
  }

  // normalize flag
  var paddingLeft = 18 //TODO edited par bleu122
  var paddingTouchBtn = 6 //TODO edited par bleu122
  var paddingLeftMinusPaddingTouchBtn = paddingLeft - paddingTouchBtn //TODO edited par bleu122
  var halfOfWidthOfTouchBtn = 11 //TODO edited par bleu122
  var normalizeFact = 0 //TODO edited par bleu122

  self.slider = slider
  self.reset = function () {
    touchRight.style.left = paddingLeftMinusPaddingTouchBtn + 'px'
    lineSpan.style.marginLeft = '0px'
    lineSpan.style.width = '0px'
    startX = 0
    x = 0
  }

  self.setValue = function (value, maxX) {
    var ratio = (value - min) / (max - min)

    if(ratio === 1) {
      touchRight.style.left = maxX + 'px'
    } else {
      touchRight.style.left =
        Math.ceil(
          ratio * (slider.offsetWidth - 2*paddingLeft - 2*paddingTouchBtn - (normalizeFact))
        ) + paddingLeftMinusPaddingTouchBtn + 'px'
    }

    lineSpan.style.marginLeft = '0px'
    lineSpan.style.width = touchRight.offsetLeft + 'px'

    slider.setAttribute('se-value', value)
  }

  // initial reset
  self.reset()

  // usefull values, min, max, normalize fact is the width of both touch buttons
  var minX = paddingLeftMinusPaddingTouchBtn
  var maxX = slider.offsetWidth - touchRight.offsetWidth - paddingLeftMinusPaddingTouchBtn
  var selectedTouch = null

  // var initialValue = lineSpan.offsetWidth - normalizeFact
  var initialValue = maxX - normalizeFact - paddingLeftMinusPaddingTouchBtn

  // set default values
  self.setValue(defaultValue, maxX)

  // setup touch/click events
  function onStart (event) {
    // Prevent default dragging of selected content
    event.preventDefault()

    var eventTouch = event

    if (event.touches) {
      eventTouch = event.touches[0]
    }

    if (this === touchRight) {
      x = touchRight.offsetLeft
    }

    startX = eventTouch.pageX - x
    selectedTouch = this
    document.addEventListener('mousemove', onMove)
    document.addEventListener('mouseup', onStop)
    document.addEventListener('touchmove', onMove)
    document.addEventListener('touchend', onStop)
  }

  function onMove (event) {
    var eventTouch = event

    if (event.touches) {
      eventTouch = event.touches[0]
    }

    x = eventTouch.pageX - startX

    if (selectedTouch === touchRight) {
      if (x < minX) {
        x = minX
      } else if (x > maxX) {
        x = maxX
      }
      selectedTouch.style.left = x + 'px'
    }

    // update line span
    lineSpan.style.width = touchRight.offsetLeft + 'px'

    // write new value
    calculateValue()

    // call on change
    if (slider.getAttribute('on-change')) {
      // eslint-disable-next-line no-new-func
      var fn = new Function('value', slider.getAttribute('on-change'))
      fn(
        slider.getAttribute('se-value')
      )
    }

    if (self.onChange) {
      self.onChange(
        slider.getAttribute('se-value')
      )
    }
  }

  function onStop (event) {
    document.removeEventListener('mousemove', onMove)
    document.removeEventListener('mouseup', onStop)
    document.removeEventListener('touchmove', onMove)
    document.removeEventListener('touchend', onStop)

    selectedTouch = null

    // write new value
    calculateValue()

    // call did changed
    if (slider.getAttribute('did-changed')) {
      // eslint-disable-next-line no-new-func
      var fn = new Function('value', slider.getAttribute('did-changed'))
      fn(
        slider.getAttribute('se-value')
      )
    }

    if (self.didChanged) {
      self.didChanged(
        slider.getAttribute('se-value')
      )
    }
  }

  function calculateValue () {
    var value = ((lineSpan.offsetWidth - paddingLeftMinusPaddingTouchBtn) * (max - min) / initialValue) + 1

    // console.log(step)
    if (step !== 0.0) {
      var multi = Math.floor(value / step)
      value = step * multi
    }

    slider.setAttribute('se-value', value)
  }

  // link events
  touchRight.addEventListener('mousedown', onStart)
  touchRight.addEventListener('touchstart', onStart)
}



// WEBPACK FOOTER //
// ./src/components/b122/editFields/ZbRangeSlider2.js